import React from 'react';

import http from 'api/http';
import { boatAPI } from 'api/requests';

import MatrixInput from './MatrixInput';
import ApplicationActions from 'Components/ApplicationActions';
import Slider from 'Components/Slider';
import { CalculatedOutput } from 'Components/CalculatedOutput';

class BoatDimensions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props.boat.cubicCapacity,
      calculatedPontoonDiameter: props.boat.cubicCapacity.calculatedPontoonDiameter || 0,
      calculatedPontoonLength: props.boat.cubicCapacity.calculatedPontoonLength || 0,
      calculatedTubesVolume: props.boat.cubicCapacity.calculatedTubesVolume || 0,
      areaPictureStyle: 'default-picture',
    };

    this.boatDimensionsTable = {
      columns: [{name: 'Port', targetFieldId: 'PORT',}, {name: 'Starboard', targetFieldId: 'STARBOARD',}],
      rows: [
        {
          name: 'Pontoon Section Length',
          units: ' In.',
          targetFieldId: 'sectionLength',
          isInput: true,
          digitsAfterDot: 2
        },
        {name: 'Total Pontoon Length', units: ' In.', targetFieldId: 'totalLength', isInput: true, digitsAfterDot: 0},
        {name: 'Pontoon Diameter', units: ' In.', targetFieldId: 'diameter', isInput: true, digitsAfterDot: 2}]
    };

    this.boatVolumeTable = {
      columns: [{name: 'Port', targetFieldId: 'PORT',}, {name: 'Starboard', targetFieldId: 'STARBOARD',}],
      rows:
        [
          {
            name: 'Volume Pontoon Section',
            units: 'Cu.Ft',
            targetFieldId: 'volumeOfSection',
            isInput: false,
            digitsAfterDot: 2
          },
          {
            name: 'Volume of End Cap',
            units: 'Cu.Ft',
            targetFieldId: 'volumeOfEndCap',
            isInput: true,
            digitsAfterDot: 2
          },
          {
            name: 'Volume of Nose Cone',
            units: 'Cu.Ft',
            targetFieldId: 'volumeOfNoseCone',
            isInput: true,
            digitsAfterDot: 2
          },
          {
            name: 'Volume of Others',
            units: 'Cu.Ft',
            targetFieldId: 'volumeOfOthers',
            isInput: true,
            digitsAfterDot: 2,
            allowNegative: true,
          },
          {
            name: 'Total Volume per Tube',
            units: 'Cu.Ft',
            targetFieldId: 'totalVolumePerTube',
            isInput: false,
            digitsAfterDot: 2
          }
        ]
    };

    if (this.state.hasCenterTube) {
      this.boatDimensionsTable.columns.splice(1, 0, {name: 'Center', targetFieldId: 'CENTER'});
      this.boatVolumeTable.columns.splice(1, 0, {name: 'Center', targetFieldId: 'CENTER'});
    }

    this.calculatedColumns = {};
  }

  showSelectedAreaPicture = areaStyleName => () => {
    this.setState({areaPictureStyle: areaStyleName});
  };

  showDefaultAreaPicture = () => {
    this.setState({areaPictureStyle: 'default-picture'});
  };

  handleMatrixChange = matrixName => (columnId, rowId) => (value, error) => {
    const {markStepAsRedacted} = this.props;
    const {invalidCells, tubes} = this.state;

    markStepAsRedacted();
    if (error || !value) {
      invalidCells[columnId][rowId] = true;
    } else {
      if (invalidCells[columnId][rowId]) delete invalidCells[columnId][rowId];
    }

    tubes[columnId][rowId] = value;

    if (this.calculatedColumns[columnId]) delete this.calculatedColumns[columnId];

    this.setState({tubes, invalidCells}, () => {
      this.isMatrixFilled(matrixName, rowId)
        .then(() => {
          if (!this.isFirstTypeForLastValue) {
            this.isFirstTypeForLastValue = true;

            if (this.timerIndex) clearTimeout(this.timerIndex);

            this.timerIndex = setTimeout(() => {
              this.isFirstTypeForLastValue = false;
              this.calculateData();
            }, 1000);
          }
        });
    });
  };

  toggleThreeTubes = () => {
    const {markStepAsRedacted} = this.props;
    const {hasCenterTube, invalidCells, tubes} = this.state;

    markStepAsRedacted();
    if (!hasCenterTube) {
      this.boatDimensionsTable.columns.splice(1, 0, {name: 'Center', targetFieldId: 'CENTER'});
      this.boatVolumeTable.columns.splice(1, 0, {name: 'Center', targetFieldId: 'CENTER'});
      tubes.CENTER = {
        diameter: 0,
        sectionLength: 0,
        totalLength: 0,
        totalVolumePerTube: 0,
        type: 'CENTER',
        volumeOfEndCap: 0,
        volumeOfNoseCone: 0,
        volumeOfOthers: 0,
        volumeOfSection: 0,
      };
      const state = {hasCenterTube: true, tubes};
      if (!invalidCells.CENTER) state.invalidCells = {...invalidCells, CENTER: {}};
      this.setState(state);
    } else {
      this.boatDimensionsTable.columns.splice(1, 1);
      this.boatVolumeTable.columns.splice(1, 1);
      delete invalidCells.CENTER;
      const state = {hasCenterTube: false, invalidCells};
      this.setState(state);
    }
  };

  isMatrixFilled = (matrixName) => {
    const {invalidCells, tubes} = this.state;
    const table = (matrixName === 'tubeBody') ? this.boatDimensionsTable : this.boatVolumeTable;

    return new Promise((resolve, reject) => {
      let matrixFilled = true;
      table.columns.forEach(column => {
        table.rows.forEach(row => {
          if (row.isInput &&
            ((invalidCells[column.targetFieldId][row.targetFieldId]) ||
              (tubes[column.targetFieldId][row.targetFieldId] === undefined || tubes[column.targetFieldId][row.targetFieldId] === null))) {
            matrixFilled = false;
          }
        });
        if (matrixName === 'tubeNose' && matrixFilled && !this.calculatedColumns[column.targetFieldId]) {
          this.calculatedColumns[column.targetFieldId] = true;
          resolve();
        }
      });
      if (matrixFilled) resolve(); else reject();
    });
  };

  validateStep = () => {
    const {invalidCells, tubes} = this.state;

    return new Promise((resolve, reject) => {
      this.boatDimensionsTable.columns.forEach(column => {
        this.boatDimensionsTable.rows.forEach(row => {
          if ((tubes[column.targetFieldId][row.targetFieldId] <= 0 || tubes[column.targetFieldId][row.targetFieldId] === undefined) && row.isInput) {
            invalidCells[column.targetFieldId][row.targetFieldId] = true;
          }
        });
      });
      this.boatVolumeTable.columns.forEach(column => {
        this.boatVolumeTable.rows.forEach(row => {
          if ((tubes[column.targetFieldId][row.targetFieldId] === undefined || tubes[column.targetFieldId][row.targetFieldId] === null) && row.isInput) {
            invalidCells[column.targetFieldId][row.targetFieldId] = true;
          }
        });
      });

      Object.keys(invalidCells).forEach(columnId => {
        if (Object.keys(invalidCells[columnId]).length) {
          reject();
          this.setState({invalidCells});
        }
      });
      resolve();
    });
  };

  calculateData = isFinal => {
    const {id} = this.props.boat;
    const {hasCenterTube, tubes} = this.state;

    let dataPayload = {
      hasCenterTube,
      tubes: [],
      saveCalculations: !!isFinal,
    };

    this.boatDimensionsTable.columns.forEach(column => {
      let tube = {'type': column.targetFieldId};

      this.boatDimensionsTable.rows.forEach(row => {
        if (row.isInput && tubes[column.targetFieldId][row.targetFieldId] !== undefined) {
          tube[row.targetFieldId] = tubes[column.targetFieldId][row.targetFieldId];
        }
      });
      this.boatVolumeTable.rows.forEach(row => {
        if (row.isInput && tubes[column.targetFieldId][row.targetFieldId] !== undefined) {
          tube[row.targetFieldId] = tubes[column.targetFieldId][row.targetFieldId];
        }
      });

      dataPayload.tubes.push(tube);
    });

    return new Promise((resolve, reject) => {
      http.put(boatAPI.calculatPontoonCapacity(id), dataPayload)
        .then(({data}) => {
          let portData = 0;
          let starPortData = 0;
          let thirdRailData = 0;
          data.tubes.forEach(tube => {
            switch (tube.type) {
              case 'PORT':
                portData = tube;
                break;
              case 'STARBOARD':
                starPortData = tube;
                break;
              case 'CENTER':
                thirdRailData = tube;
                break;
              default:
                break;
            }
          });

          let tubes =
            {
              'PORT': {...this.state.tubes.PORT, volumeOfSection: portData.volumeOfSection, totalVolumePerTube: portData.totalVolumePerTube},
              'STARBOARD': {...this.state.tubes.STARBOARD, volumeOfSection: starPortData.volumeOfSection, totalVolumePerTube: starPortData.totalVolumePerTube},
              'CENTER': {},
            };
          if (hasCenterTube && thirdRailData !== 0) tubes['CENTER'] =
            {...this.state.tubes.CENTER, volumeOfSection: thirdRailData.volumeOfSection, totalVolumePerTube: thirdRailData.totalVolumePerTube};

          this.setState({
            tubes,
            calculatedPontoonDiameter: data.avgOfDiameter,
            calculatedPontoonLength: data.avgOfTotalLength,
            calculatedTubesVolume: data.totalVolumeOfAllTubes
          }, resolve());
        })
        .catch(() => {
          reject();
        });
    });
  };

  handleMoveToNextStep = () => {
    const {updateBoatDetails, goToStep} = this.props;

    this.validateStep()
      .then(() => {
        this.calculateData(true)
          .then(() => {
            updateBoatDetails({cubicCapacity: {...this.state}});
            goToStep('next', true);
          });
      });
  };

  handleMoveToArbitraryStep = stepId => {
    const {goToStep, stepIsChanged, updateBoatDetails} = this.props;

    if (!stepIsChanged) {return goToStep(typeof stepId === 'string' ? stepId : 'prev', true);}

    this.validateStep()
      .then(() => {
        this.calculateData()
          .then(() => {
            updateBoatDetails({cubicCapacity: {...this.state}});
            goToStep(typeof stepId === 'string' ? stepId : 'prev', true);
          });
      })
      .catch(() => {
        goToStep(typeof stepId === 'string' ? stepId : 'prev', false);
      });

  };

  render() {
    const {
      hasCenterTube, tubes, invalidCells,
      calculatedPontoonDiameter, calculatedPontoonLength, calculatedTubesVolume,
      areaPictureStyle
    } = this.state;
    const {getNavBar, getHeader, stepIsChanged, updateBoatDetails} = this.props;

    return (
      <React.Fragment>
        {getHeader(() => {
          return new Promise(resolve => {
            this.validateStep().then(() => {
              this.calculateData(true).then(() => {
                updateBoatDetails({ cubicCapacity: { ...this.state } });
                resolve();
              });
            });
          });
        })}

        {getNavBar(this.handleMoveToNextStep, this.handleMoveToArbitraryStep)}

        <section className='scene_section tube-amount-choose-section _border_top_1'>
          <header>Pontoon Tubes</header>
          <div className='slider-wrapper'>
            <Slider
              state={hasCenterTube !== true}
              mainWrapperClassName='green'
              label='Number of Tubes'
              onLabel='Two'
              offLabel='Three'
              toggleAction={this.toggleThreeTubes}
            />
          </div>
        </section>

        <section className='scene_section boat-dimensions-section'>
          <header>Boat Dimensions</header>
          <MatrixInput
            areas={tubes}
            table={this.boatDimensionsTable}
            handleMatrixChange={this.handleMatrixChange('tubeBody')}
            showSelectedAreaPicture={this.showSelectedAreaPicture}
            showDefaultAreaPicture={this.showDefaultAreaPicture}
            invalidCells={invalidCells}
          />
          <div className='output-wrapper'>
            <CalculatedOutput
              mainWrapperClassName='_margin_right_30'
              label='Average of Pontoon Diameter'
              value={calculatedPontoonDiameter}
              units=' In.'
            />
            <CalculatedOutput label='Average of Total Pontoon Length' value={calculatedPontoonLength} units='In.' />
          </div>
          <div className={`area-picture ${areaPictureStyle}`} />
          <header>Boat Volume</header>
          <MatrixInput
            areas={tubes}
            table={this.boatVolumeTable}
            handleMatrixChange={this.handleMatrixChange('tubeNose')}
            showSelectedAreaPicture={this.showSelectedAreaPicture}
            showDefaultAreaPicture={this.showDefaultAreaPicture}
            invalidCells={invalidCells}
          />
          <CalculatedOutput label='Total Volume of All Tubes' value={calculatedTubesVolume} units='Cu. Ft.' />
        </section>

        <ApplicationActions
          backButtonLabel={'Prev. Step'}
          saveButtonLabel={'Next Step'}
          saveButtonAction={
            stepIsChanged
              ? this.handleMoveToNextStep
              : () => {
                this.handleMoveToArbitraryStep('next');
              }
          }
          backButtonAction={this.handleMoveToArbitraryStep}
        />
      </React.Fragment>
    );
  }
}

export default BoatDimensions;



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/CubicCapacityScene/BoatDimensions.jsx